import React from 'react';
import ReactGA from 'react-ga';

import { YMInitializer as YM } from 'react-yandex-metrika';

import { LanguageProvider } from './containers/Language';

import ReactPixel from 'react-facebook-pixel';

import TagManager from 'react-gtm-module';

import Navigation from './components/Navigation/Navigation'
import Main from './components/Main/Main';
import Benefits from './components/Benefits/Benefits';
import Partners from './components/Partners/Partners';
import Feedbacks from './components/Feedbacks/Feedbacks';
import Calculator from './components/Calculator/Calculator';
import FAQ from './components/FAQ/FAQ';
import Footer from './components/Footer/Footer';
import ImageSection from './components/ImageSection/ImageSection';


//#region TagManager
const tagManagerArgs = {
    gtmId: 'GTM-T9GRS85'
}

TagManager.initialize(tagManagerArgs)
//#endregion


//#region Google analytics
ReactGA.initialize('UA-33303280-8');
ReactGA.pageview(window.location.pathname);
//#endregionl

//#region  Facebook Pixel
ReactPixel.init('250235773428490');
ReactPixel.pageView(); // For tracking page view
//#endregion




function App() {
  const [fromMdoal, setFromModal] = React.useState(true)
  const [count, setCount] = React.useState(0)

  const handleChange  = (newVal) => {
    setFromModal(newVal)
    setCount(prev=> prev+1)
  }
  
  return (
    
  <LanguageProvider>
    <YM accounts={[56379571]} 
        options={
          {webvisor: true,
          clickmap:true,
          trackLinks:true,
          accurateTrackBounce:true}
          } />
    <Navigation onSetFromModal={handleChange}/>
    <Main/>
    <Benefits valueFromNav={fromMdoal} count={count}/>
    <Partners/>
    <Feedbacks/>
    <Calculator/>
    <FAQ/>
    <ImageSection />
    <Footer/>
  </LanguageProvider>
  );
}

export default App;
